import * as React from 'react';
import { Box, Grid, Button, TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Snackbar, Alert, Autocomplete } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Modal from '@mui/material/Modal';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth < 767 ? '80%' : 600,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const FiltersComp = (props) => {



    return (
        <Box>
            <Modal
                open={true}
                onClose={() => props.ToggleFilterBox()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box p={1}>
                        <Typography className='grey-theme-btn' variant="h6" component="h2">
                            Search Data
                        </Typography>
                    </Box>

                    <Grid container>

                        <Grid xs={12} md={6}>
                            <Box pl={1} pr={1}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtLeadSearchStartDate')} label="Start Date"
                                            value={props.SearchFormData.txtLeadSearchStartDate !== '' ? dayjs(props.SearchFormData.txtLeadSearchStartDate) : null}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Box>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Box pl={1} pr={1}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtLeadSearchEndDate')} label="End Date"
                                            value={props.SearchFormData.txtLeadSearchEndDate !== '' ? dayjs(props.SearchFormData.txtLeadSearchEndDate) : null}
                                        //value={dayjs(props.SearchFormData.txtLeadSearchEndDate != undefined ? props.SearchFormData.txtLeadSearchEndDate : '')}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Box>
                        </Grid>

                        {
                            props.mystate.type === 'Student' ?

                                <Grid item xs={12} md={6}>
                                    <Box p={1}>
                                        <TextField
                                            select
                                            fullWidth
                                            label="German Level"
                                            value={props.SearchFormData.ddlGermanLevel || ''}

                                            onChange={(e) =>
                                                props.HandleInputs(e, 'ddlGermanLevel')
                                            }
                                        >
                                            <MenuItem value="A1">A1</MenuItem>
                                            <MenuItem value="A2">A2</MenuItem>
                                            <MenuItem value="B1">B1</MenuItem>
                                            <MenuItem value="B2">B2</MenuItem>
                                            <MenuItem value="C1">C1</MenuItem>
                                        </TextField>
                                    </Box>
                                </Grid>

                                :
                                null

                        }
                        {
                            props.mystate.type === 'Student' ?

                                <Grid item xs={12} md={6}>
                                    <Box p={1}>
                                        <TextField
                                            select
                                            fullWidth
                                            label="Marital Status"
                                            value={props.SearchFormData.ddlMaritalStatus || ''}
                                            onChange={(e) =>
                                                props.HandleInputs(e, 'ddlMaritalStatus')
                                            }
                                        >
                                            <MenuItem value="Single">Single</MenuItem>
                                            <MenuItem value="Married">Married</MenuItem>
                                        </TextField>
                                    </Box>
                                </Grid>

                                :
                                null

                        }


                        {
                            props.mystate.type !== 'Student' && (props.mystate.userData.profile === 'Sales TL' || props.mystate.userData.profile === 'Admin') ?
                                <Grid xs={12} md={6}>
                                    <Box p={1}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Select Department</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={props.SearchFormData.ddlLeadSearchDepartment || ''}
                                                label="User Type"
                                                error={props.SearchFormData.ddlLeadSearchDepartmentErr == undefined || props.SearchFormData.ddlLeadSearchDepartmentErr == '' ? false : true}
                                                onChange={(e) => props.HandleInputs(e, 'ddlLeadSearchDepartment')}
                                            >
                                                {
                                                    props.mystate.profileListData.length > 0 ?
                                                        props.mystate.profileListData.map((item) =>
                                                            props.mystate.userData.profile === 'Admin' ?
                                                                <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                                                :
                                                                item.profile_name === 'Sales' ?
                                                                    <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                                                    :
                                                                    null
                                                        )
                                                        :
                                                        null
                                                }
                                            </Select>
                                            <FormHelperText style={{ color: 'red' }}>{props.SearchFormData.ddlLeadSearchDepartmentErr}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                :
                                null
                        }

                        {
                            props.mystate.type !== 'Student' && (props.mystate.userData.profile === 'Sales TL' || props.mystate.userData.profile === 'Admin') ?
                                <Grid xs={12} md={6}>
                                    <Box p={1}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Select Owner</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={props.SearchFormData.ddlLeadSearchOwner || []}
                                                label="User Type"
                                                multiple={true}
                                                error={props.SearchFormData.ddlLeadSearchOwnerErr == undefined || props.SearchFormData.ddlLeadSearchOwnerErr == '' ? false : true}
                                                onChange={(e) => props.HandleInputs(e, 'ddlLeadSearchOwner')}
                                            >
                                                {
                                                    props.mystate.userListData.length > 0 ?

                                                        props.mystate.userListData.map((item) =>
                                                            item.user_profile_name === props.SearchFormData.ddlLeadSearchDepartment ?
                                                                <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                                :
                                                                null
                                                        )
                                                        :
                                                        null
                                                }
                                            </Select>
                                            <FormHelperText style={{ color: 'red' }}>{props.SearchFormData.ddlLeadSearchOwnerErr}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                :
                                null

                        }

                        <Grid xs={12} md={6}>
                            <Box p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={props.SearchFormData.ddlLeadSearchStatus || ''}
                                        label="User Type"
                                        error={props.SearchFormData.ddlLeadSearchStatusErr == undefined || props.SearchFormData.ddlLeadSearchStatusErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadSearchStatus')}
                                    >
                                        {
                                            props.mystate.statusListData.map((item, i) =>
                                                <MenuItem key={i} value={item}>{item}</MenuItem>
                                            )
                                        }
                                    </Select>
                                    <FormHelperText style={{ color: 'red' }}>{props.SearchFormData.ddlLeadSearchStatusErr}</FormHelperText>
                                </FormControl>
                            </Box>
                        </Grid>
                        
                        {props.mystate.type !== 'Student' ?
                            <Grid xs={12} md={6}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            fullWidth
                                            label="City"
                                            value={props.SearchFormData.txtSearchCity || ''}
                                            onChange={(e) => props.HandleInputs(e, 'txtSearchCity')}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                            :
                            null}


                        {
                            props.mystate.type === 'Student' ?
                                <Grid item xs={12} md={6}>
                                    <Box p={1}>
                                        <Autocomplete
                                            options={props.mystate.instituteListData || []}
                                            getOptionLabel={(option) => option.institute_name || ''}
                                            value={
                                                props.mystate.instituteListData.find(
                                                    item =>
                                                        item.institute_name ===
                                                        props.SearchFormData.txtSearchInstitute
                                                ) || null
                                            }
                                            onChange={(event, newValue) => {
                                                props.HandleInputs(
                                                    {
                                                        target: {
                                                            value: newValue?.institute_name || ''
                                                        }
                                                    },
                                                    'txtSearchInstitute'
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Student Referred By"
                                                    error={Boolean(
                                                        props.SearchFormData.txtSearchInstituteErr
                                                    )}
                                                />
                                            )}
                                        />

                                    </Box>
                                </Grid>
                                :
                                null
                        }


                    </Grid>


                    <Box mt={2} p={1}>
                        <Grid container>
                            <Grid sx={6}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.SearchData()}>Search Data</Button>
                            </Grid>
                            <Grid sx={6} ml={2}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleFilterBox()}>Cancel</Button>
                            </Grid>
                        </Grid>
                    </Box>

                </Box>
            </Modal>

            <Snackbar open={props.mystate.showAlert} autoHideDuration={3000} onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}>
                <Alert
                    onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>

        </Box>


    );
}